module.exports = __webpack_public_path__ + "img/five-pop-bg-pc.1e9a537d.png";